import React from 'react';
import {ConnectedRouter} from 'connected-react-router'
import {Provider} from 'react-redux';
import {Route, Switch} from 'react-router-dom';

import configureStore, {history} from './store';
// import './firebase/firebase';
import App from './containers/App';
import AuthSocket from "./util/AuthSocket";
import ReportFilterWidget from "./widgets/ReportFilterWidget";
import MobilePlatformGate from "./util/MobilePlatformGate";

export const store = configureStore();

const MainApp = () =>
  <Provider store={store}>
      <MobilePlatformGate>
      <ConnectedRouter history={history}>
          <Switch>
              <Route path="/widgets/report-filter" component={ReportFilterWidget}/>
              <Route path="/" component={App}/>
          </Switch>
      </ConnectedRouter>
      </MobilePlatformGate>
      <AuthSocket />
  </Provider>;

export default MainApp;